import { ArrowRight } from "lucide-react";

type CcCardReadMoreLabelProps = {
  children: string;
  className?: string;
};

/** Inline “Read more” label + arrow for card footers (parent must be the card link). */
export function CcCardReadMoreLabel({ children, className }: CcCardReadMoreLabelProps) {
  return (
    <span className={["cc-card-read-more", className].filter(Boolean).join(" ")}>
      <span className="cc-card-read-more__label">{children}</span>
      <span className="cc-card-read-more__arrow" aria-hidden="true">
        <ArrowRight size={16} strokeWidth={2} />
      </span>
    </span>
  );
}
